import { Pipe, PipeTransform } from '@angular/core';
import { IAdditionalVehicles } from '../interfaces';
import { ParkerStateService } from 'src/app/core/services/state/parker-state.service';

@Pipe({ name: 'additionalVehicleList' })
export class AdditionalVehiclesPipe implements PipeTransform {
  additionalVehicleList: IAdditionalVehicles[];
  vehicleDisplay: string = '';

  constructor(private parkerStateService: ParkerStateService) {
    this.additionalVehicleList = this.parkerStateService.getAdditionalVehicleData();
  }

  transform(parkerId: string) {
    if (!parkerId) {
      return '';
    }

    let ii = 0;
    let firstVehicleFound = false;
    for (ii = 0; ii < this.additionalVehicleList.length; ii++) {
      if (this.additionalVehicleList[ii].parkerId === parkerId) {
        let thisVehicle = '';
        if (firstVehicleFound) {
          this.vehicleDisplay += '\n';
        }
        firstVehicleFound = true;

        let foundVehicle = this.additionalVehicleList[ii];

        thisVehicle = foundVehicle.vehicleLicense;

        if (foundVehicle.vehicleModel != '') thisVehicle += ' ' + foundVehicle.vehicleModel;

        if (foundVehicle.vehicleModel != '') thisVehicle += ' ' + foundVehicle.vehicleMake;

        if (foundVehicle.vehicleState != '') thisVehicle += ' ' + foundVehicle.vehicleState;

        if (foundVehicle.vehicleColor != '') thisVehicle += ' ' + foundVehicle.vehicleColor;

        this.vehicleDisplay = this.vehicleDisplay + thisVehicle;
      }
    }

    return this.vehicleDisplay;
  }
}
